// OverlayUploader — kapselt die Plupload-CORE-Anbindung des Overlay-Uploads + die Upload-Bereich-UI
// (#filelist / #console / #uploadfiles). Kein Overlay-State, keine Karte, kein jQuery.
//
// Nutzt das GLOBALE `plupload` (als Script in overlays.php geladen, NICHT gebündelt) → die Abhängigkeit
// bleibt am Rand sichtbar; aufgelöst erst zur Aufrufzeit (createOverlayUploader läuft spät, nach dem
// plupload-Script). Naht zur Seite: meldet den Upload-Abschluss als Bus-Event (UPLOAD_COMPLETE) — was
// dann passiert (heute: Reload), entscheidet der Abonnent, nicht dieses Modul.

import { mediator } from "../mediator/mediatorInstance.js";
import { OVERLAY_EVENTS } from "../overlayAdmin/overlayEvents.js";

export function createOverlayUploader() {
    const uploader = new plupload.Uploader({
        runtimes: 'html5,flash,html4',
        browse_button: 'pickfiles',                          // DOM-id (Plupload-CORE), element-agnostisch
        container: document.getElementById('container'),
        max_file_size: '100mb',
        chunk_size: '1mb',
        url: '/overlays.php',                                // Chunk-Endpoint (oberer Teil von overlays.php)
        flash_swf_url: '../../js/Moxie.swf',                 // Flash-Fallback
        filters: [
            { title: 'Image files', extensions: 'jpg,gif,png' }
        ],
        init: {
            PostInit: function () {
                document.getElementById('filelist').innerHTML = '';
                document.getElementById('uploadfiles').onclick = function () {
                    uploader.start();
                    return false;
                };
            },
            FilesAdded: function (up, files) {
                plupload.each(files, function (file) {
                    document.getElementById('filelist').innerHTML += '<div id="' + file.id + '">' + file.name + ' (' + plupload.formatSize(file.size) + ') <b></b></div>';
                    document.getElementById('uploadfiles').removeAttribute('disabled');
                });
            },
            UploadProgress: function (up, file) {
                document.getElementById(file.id).getElementsByTagName('b')[0].innerHTML = '<span>' + file.percent + "%</span>";
            },
            Error: function (up, err) {
                document.getElementById('console').innerHTML += "\nError #" + err.code + ": " + err.message;
            },
            UploadComplete: function (up, files) {
                document.getElementById('filelist').innerHTML += '<div> UploadComplete </div>';
                // Abschluss melden; Reload (oder später anderes) hängt am Abonnenten, nicht hier.
                mediator.publish(OVERLAY_EVENTS.UPLOAD_COMPLETE, { files: files });
            }
        }
    });

    uploader.init();
    return uploader;
}
